import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';

import { userInfoKeys } from 'api/quires/queryKeys';
import { UserSelectSearchRequest } from 'api/searchRequest/UserSelectSearchRequest';
import { getUserInfoList } from 'api/userApi';
import UserSelectSearchBox from 'components/searchbox/UserSelectSearchBox';
import Pagination from 'components/widget/Pagination';
import { User } from 'model/User';
import { useRecoilValue } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { YN_TYPE } from 'types/enumType';
import { containsSpecialCharAndSql } from 'util/commonUtil';
import { decryptId } from 'util/encryptUtil';
import { hideBackDropStyles } from 'util/styleUtil';

import UserSearchTable from './UserSearchTable';

export interface UserSearchModalProps {
  isOpen: boolean;
  onSelect: (user: User) => void;
  onClose: () => void;
  inHouseYn?: YN_TYPE;
  // onSubmit: () => void;
}

export default function UserSearchModal({
  isOpen,
  onSelect,
  onClose, // onSubmit,
  inHouseYn = YN_TYPE.Y,
}: UserSearchModalProps) {
  const { t } = useTranslation();

  const userInfo = useRecoilValue(userInfoState);

  const [searchRequest, setSearchRequest] = useState<UserSelectSearchRequest>(
    () => {
      const req = new UserSelectSearchRequest(
        1,
        10,
        userInfo.local ?? '',
        decryptId(userInfo?.factoryId ?? ''),
        inHouseYn === YN_TYPE.Y ? decryptId(userInfo.deptId ?? '') : '', // 작업 허가서 생성을 통해 들어오면 deptId 생략
        inHouseYn,
      );
      req.activate = YN_TYPE.Y;
      return req;
    },
  );

  const { data, refetch, remove, isLoading } = useQuery({
    queryKey: userInfoKeys.list(searchRequest),
    queryFn: () => getUserInfoList(searchRequest),
    enabled: isOpen,
  });

  const onSearchSubmit = (formData: UserSelectSearchRequest) => {
    if (containsSpecialCharAndSql(formData.searchKey)) {
      alert(t('conclusion.notIncludeSQL'));
      return;
    }

    setSearchRequest((prev) => ({
      ...prev,
      ...formData,
      page: 1,
    }));

    setTimeout(() => refetch());
  };

  const handleSelect = (user: User) => {
    remove();

    onSelect(user);
  };

  const onChangePage = (page: number) => {
    setSearchRequest((prev) => ({ ...prev, page }));
  };

  return (
    <ReactModal
      isOpen={isOpen}
      style={hideBackDropStyles}
      onRequestClose={onClose}
    >
      <div id={'popup-wrap'} className={'user-edit-modal'}>
        <div className={'popup-wrap'}>
          <div className={'popup-head'}>
            <p className={'poptit'}>{t('user.userSelect')}</p>
          </div>
          <div className={'popup-cont'}>
            <div>
              <div className={'user-search-wrap'}>
                <div className={'cont-wrap'}>
                  <div className={'box-wrap w100p'}>
                    <div className={'box'}>
                      <UserSelectSearchBox
                        searchRequest={searchRequest}
                        onSubmit={onSearchSubmit}
                      />
                    </div>
                    <div className={'user-wrap block'}>
                      <div className={'tbl-wrap '}>
                        {/* searchBox */}
                        <UserSearchTable
                          userList={data?.list ?? []}
                          onSelect={handleSelect}
                        />
                      </div>
                    </div>
                    <Pagination
                      page={searchRequest.page}
                      totalCount={data?.totalCount ?? 0}
                      count={searchRequest.count}
                      onPageClick={onChangePage}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={'tc'}>
              <button
                type={'button'}
                className={'gray_white_btn'}
                onClick={onClose}
              >
                {t('button.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
